import { render, staticRenderFns } from "./ChangeArticleCalculations.vue?vue&type=template&id=5185d767"
import script from "./ChangeArticleCalculations.vue?vue&type=script&lang=js"
export * from "./ChangeArticleCalculations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports